import React from 'react';
import cn from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useReviewStars from './useReviewStars';

type Props = {
  rating: number;
  reviewsCount: number;
  showWriteReviewLink?: boolean;
  className?: string;
  onClick?: () => void;
  invertedColors?: boolean;
  showReviewsLabel?: boolean;
};

export default function ReviewStars({
  rating,
  reviewsCount,
  showWriteReviewLink,
  onClick,
  className,
  invertedColors,
  showReviewsLabel,
}: Props) {
  const stars = useReviewStars(rating);

  return (
    <div className={cn('group inline-block', { 'cursor-pointer': !!onClick }, className)} onClick={onClick}>
      <span>
        {stars.map((star, index) => {
          return <FontAwesomeIcon key={index} icon={star.icon} className="text-amber-500" />;
        })}
      </span>
      <span
        className={cn(
          'font-medium ml-1',
          {
            'group-hover:text-amber-700 group-active:text-amber-900 group-hover:underline':
              !!onClick && !invertedColors,
            'group-hover:text-white group-active:text-white group-hover:underline': !!onClick && invertedColors,
            'text-sm': reviewsCount === 0 && showWriteReviewLink,
          },
          invertedColors ? 'text-white' : 'text-amber-800'
        )}
      >
        (
        {reviewsCount > 0 || !showWriteReviewLink
          ? `${reviewsCount.toLocaleString('en-US')}${
              showReviewsLabel ? ` Review${reviewsCount === 1 ? '' : 's'}` : ''
            }`
          : 'Write a Review'}
        )
      </span>
    </div>
  );
}
